import { cn, getText, interpolate } from "shared/lib";

import { useMediaQuery } from "shared/hooks";
import { Separator } from "shared/components";

export function AnalysisExclusionsQld() {
  const md = useMediaQuery({
    query: "(min-width: 768px)",
  });

  return (
    <div
      className={cn(
        "flex grow flex-col overflow-y-auto px-5 py-5 md:pt-2",
        !md ? "bg-interfaceBgLightPaper" : "bg-interfaceBgDarkPaper",
      )}
    >
      <div
        className={cn(
          "flex grow flex-col items-center rounded-xl",
          md ? "bg-interfaceBgLightPaper" : "",
        )}
      >
        <div className="text-textPrimary mb-3 mt-4 flex w-[700px] max-w-[700px] flex-col gap-3 md:mb-14 md:mt-10">
          <div className="flex flex-col gap-0.5">
            <h1 className="text-headingxl">
              {getText("What our planning enquiry reports don't account for")}
            </h1>
            <p className="text-bodysm text-textSubdued">
              {getText("Last updated 18/07/2025")}
            </p>
          </div>

          <p className="text-bodymd mt-7">
            {getText(
              "After entering an address and describing a proposal, myLot generates a planning enquiry analysis. The following factors aren't accounted for and should be kept in mind when reading the analysis.",
            )}
          </p>

          <div className="flex flex-col gap-0.5">
            <h2 className="text-bodymd font-semibold">
              {getText("1. Property restrictions like easements or covenants")}
            </h2>
            <p className="text-bodymd ml-3">
              {interpolate(
                "You can get a current title search online through {{titleLink}} to see this information.",
                {
                  titleLink: (
                    <a
                      className="text-textLink underline"
                      href="https://www.titlesqld.com.au"
                      rel="noreferrer"
                      target="_blank"
                      tabIndex={0}
                    >
                      {getText("Titles Queensland")}
                    </a>
                  ),
                },
              )}
            </p>
          </div>

          <div className="flex flex-col gap-0.5">
            <h2 className="text-bodymd font-semibold">
              {getText("2. Provisions relating to disaster recovery")}
            </h2>
            <p className="text-bodymd ml-3">
              {getText(
                "If you're re-establishing a business or rebuilding in response to an emergency such as a bushfire, please contact your Council.",
              )}
            </p>
          </div>

          <div className="flex flex-col gap-0.5">
            <h2 className="text-bodymd font-semibold">
              {getText("3. Past permits and existing use rights")}
            </h2>
            <p className="text-bodymd ml-3">
              {getText(
                "Additional conditions can be documented on your title or on a property's past development approvals. It is up to the lot's owner to prove that existing use rights apply.",
              )}
            </p>
          </div>

          <div className="flex flex-col gap-0.5">
            <h2 className="text-bodymd font-semibold">
              {getText("4. Funding and exemptions programs")}
            </h2>
            <p className="text-bodymd ml-3">
              {getText(
                "The report does not consider planning controls relating to exemptions and concessions for certain types of development, such as large residential developments and affordable housing.",
              )}
            </p>
          </div>

          <div className="flex flex-col gap-0.5">
            <h2 className="text-bodymd font-semibold">
              {getText("5. Proposals by government agencies")}
            </h2>
            <p className="text-bodymd ml-3">
              {getText(
                "The report does not consider planning scheme provisions relating to proposals submitted by government agencies and related entities.",
              )}
            </p>
          </div>

          <div className="flex flex-col gap-0.5">
            <h2 className="text-bodymd font-semibold">
              {getText(
                "6. Planning provisions relating to referral, advertising and notification requirements",
              )}
            </h2>
            <p className="text-bodymd ml-3">
              {getText(
                "The report doesn't assess the need for referrals, advertising or notification. During assessment, the designated planning officer will assess if your proposal needs to be referred, as well as any advertising and notification requirements.",
              )}
            </p>
          </div>

          <p className="text-bodymd">
            {getText(
              "This list is not exhaustive. Remember that the analysis is intended as a helpful guide. It is not a final planning decision. Always seek verification from a council planner before proceeding.",
            )}
          </p>

          <div className="mt-3 md:mt-10">
            <Separator />

            <div className="mt-3 flex flex-col gap-3 md:mt-10">
              <h1 className="text-headinglg text-textPrimary">
                {getText("Contact details")}
              </h1>

              <ul className="ml-2 list-inside list-disc">
                <li>
                  {getText("Email")}:{" "}
                  <a
                    className="text-bodymd text-textLink underline"
                    href="mailto://help@mylot.ai"
                    tabIndex={0}
                  >
                    help@mylot.ai
                  </a>
                </li>
                <li>
                  {getText("Website")}:{" "}
                  <a
                    className="text-bodymd text-textLink underline"
                    href="https://mylot.ai"
                    rel="noreferrer"
                    target="_blank"
                    tabIndex={0}
                  >
                    https://mylot.ai
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
